import { AlertTriangle, Loader2, Trash2 } from "lucide-react";
import React from "react";
import { useTranslation } from "../../contexts/LanguageContext";
import { cn } from "../../utils/cn";
import Button from "../ui/Button";
import Modal from "../ui/Modal";

interface DeletePostModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  postId: number | null;
}

const DeletePostModal: React.FC<DeletePostModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
  postId,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("Excluir Post")}
      maxWidth="max-w-md"
      footer={
        <div className="flex flex-row justify-end gap-3">
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={onClose}
            disabled={loading}
          >
            {t("Cancelar")}
          </Button>
          <Button
            type="button"
            variant="destructive"
            size="sm"
            icon={
              loading ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <Trash2 className="w-4 h-4" />
              )
            }
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? t("Excluindo...") : t("Excluir Post")}
          </Button>
        </div>
      }
    >
      <div className="py-4">
        <div className="flex items-start gap-4 mb-6">
          <div
            className={cn(
              "shrink-0 w-12 h-12 rounded-full flex items-center justify-center",
              "bg-red-100 text-red-600",
            )}
          >
            <AlertTriangle className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {t("Confirmar Exclusão")}
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              {t("Você está prestes a excluir o post")}{" "}
              <span className="font-semibold text-gray-900">#{postId}</span>.{" "}
              {t("Tem certeza que deseja continuar?")}
            </p>
          </div>
        </div>
        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
          <p className="text-xs text-red-800 font-medium">
            ⚠️ {t("Esta ação não pode ser desfeita")}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default DeletePostModal;
